<template>
  <header class="m-grid__item    m-header " data-minimize-mobile="hide" data-minimize-offset="200"
          data-minimize-mobile-offset="200" data-minimize="minimize">
    <div class="m-container m-container--fluid m-container--full-height">
      <div class="m-stack m-stack--ver m-stack--desktop">
        <div class="m-stack__item m-brand  m-brand--skin-light ">
          <div class="m-stack m-stack--ver m-stack--general">
            <div class="m-stack__item m-stack__item--middle m-brand__logo">
              <router-link :to="{ name: 'services' }" class="m-brand__logo-wrapper">
                <img alt="" style="height: 65px" src="../../../static/img/makueni-logo.png"/>
              </router-link>
            </div>
            <div class="m-stack__item m-stack__item--middle m-brand__tools">
              <a href="javascript: void(0);" id="m_aside_left_minimize_toggle"
                 class="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-desktop-inline-block">
                <span></span>
              </a>
              <a href="javascript:;" id="m_aside_left_offcanvas_toggle"
                 class="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-tablet-and-mobile-inline-block">
                <span></span>
              </a>
              <a id="m_aside_header_topbar_mobile_toggle" href="javascript:;"
                 class="m-brand__icon m--visible-tablet-and-mobile-inline-block">
                <i class="flaticon-more"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="m-stack__item m-stack__item--fluid m-header-head" id="m_header_nav">
          <span class="county-name">MAKUENI COUNTY GOVERNMENT</span>
          <div id="m_header_topbar" class="m-topbar  m-stack m-stack--ver m-stack--general">
            <div class="m-stack__item m-topbar__nav-wrapper">
              <ul class="m-topbar__nav m-nav m-nav--inline">
                <li
                  class="m-nav__item m-topbar__user-profile m-topbar__user-profile--img m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light"
                  data-dropdown-toggle="click" aria-expanded="true">
                  <a href="#" class="m-nav__link m-dropdown__toggle">
                    <span class="m-nav__link-badge m-badge m-badge--dot m-badge--dot-small m-badge--danger"></span>
                    <span class="m-nav__link-icon">
                      <i class="flaticon-user-ok"></i>
                    </span>
                    <span class="m-topbar__username" v-text="lastName"></span>
                  </a>
                  <div class="m-dropdown__wrapper">
                    <span class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"
                          style="left: auto; right: 12.5px;"></span>
                    <div class="m-dropdown__inner">

                      <div class="m-dropdown__body">
                        <div class="m-dropdown__content">
                          <ul class="m-nav m-nav--skin-light">
                            <li class="m-nav__item">
                              <router-link :to="{ name: 'profile' }" class="m-nav__link">
                                <i class="m-nav__link-icon flaticon-info"></i>
                                <span class="m-nav__link-text">Profile</span>
                              </router-link>
                            </li>
                            <li class="m-nav__separator m-nav__separator--fit">
                            </li>
                            <li class="m-nav__item">
                              <a href="javascript:;" @click="logOut"
                                 class="btn m-btn--pill btn-secondary m-btn m-btn--custom m-btn--label-brand m-btn--bolder">
                                Logout
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
  export default {
    name: "TopNav",
    data() {
      return {
        lastName: ""
      };
    },
    computed: {
      countyName() {
        return this.$store.state.activeCounty ? this.$store.state.activeCounty.countyName : "";
      }
    },
    methods: {
      logOut() {
        this.$store.commit("SET_USER", null);
        this.$store.commit("SET_TOKEN", null);
        this.$store.commit("SET_ACTIVE_COUNTY", null);

        if (window.localStorage) {
          window.localStorage.removeItem("user");
          window.localStorage.removeItem("token");
          window.localStorage.removeItem("activeCounty");
        }
        this.$router.push("/");
      }
    },
    created: function () {
      if (window.localStorage.getItem("user")) {
        this.lastName = JSON.parse(window.localStorage.getItem("user")).firstName;
      } else {
        this.lastName = "[name]";
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/navigation/TopNav.vue